export const FORSUBMIT = {
  REQUEST: 'Tickets/ForSubmit/Request',
  SUCCESS: 'Tickets/ForSubmit/Success',
  FAILURE: 'Tickets/ForSubmit/Failure'
};

export const GET = {
  REQUEST: 'Tickets/Get/Request',
  SUCCESS: 'Tickets/Get/Success',
  FAILURE: 'Tickets/Get/Failure'
};

export const UPDATE = {
  REQUEST: 'Tickets/Update/Request',
  SUCCESS: 'Tickets/Update/Success',
  FAILURE: 'Tickets/Update/Failure'
};

export const CLEAR = {
  SUCCESS: 'Tickets/Clear/Success'
};

export const CONFIRM = {
  REQUEST: 'Tickets/Confirm/Request',
  SUCCESS: 'Tickets/Confirm/Success',
  FAILURE: 'Tickets/Confirm/Failure'
};

export const CONFIRM_REJECT = {
  REQUEST: 'Tickets/ConfirmReject/Request',
  SUCCESS: 'Tickets/ConfirmReject/Success',
  FAILURE: 'Tickets/ConfirmReject/Failure'
};

export const ACCEPT_RESPONSE = {
  REQUEST: 'Tickets/AcceptResponse/Request',
  SUCCESS: 'Tickets/AcceptResponse/Success',
  FAILURE: 'Tickets/AcceptResponse/Failure'
};

export const REJECT_RESPONSE = {
  REQUEST: 'Tickets/RejectResponse/Request',
  SUCCESS: 'Tickets/RejectResponse/Success',
  FAILURE: 'Tickets/RejectResponse/Failure'
};

export const CREATE_CHANGE_REQUEST = {
  REQUEST: 'Tickets/CreateChangeRequest/Request',
  SUCCESS: 'Tickets/CreateChangeRequest/Success',
  FAILURE: 'Tickets/CreateChangeRequest/Failure'
};

export const CONFIRM_CHANGE = {
  REQUEST: 'Tickets/ConfirmChangeRequest/Request',
  SUCCESS: 'Tickets/ConfirmChangeRequest/Success',
  FAILURE: 'Tickets/ConfirmChangeRequest/Failure'
};

export const REJECT_CHANGE = {
  REQUEST: 'Tickets/RejectChangeRequest/Request',
  SUCCESS: 'Tickets/RejectChangeRequest/Success',
  FAILURE: 'Tickets/RejectChangeRequest/Failure'
};

export const ACCEPT_CHANGE_RESPONSE = {
  REQUEST: 'Tickets/AcceptChangeResponse/Request',
  SUCCESS: 'Tickets/AcceptChangeResponse/Success',
  FAILURE: 'Tickets/AcceptChangeResponse/Failure'
};

export const REJECT_CHANGE_RESPONSE = {
  REQUEST: 'Tickets/RejectChangeResponse/Request',
  SUCCESS: 'Tickets/RejectChangeResponse/Success',
  FAILURE: 'Tickets/RejectChangeResponse/Failure'
};

export const CALCULATE_BY_DAYS = {
  REQUEST: 'Tickets/CalculateByDays/Request',
  SUCCESS: 'Tickets/CalculateByDays/Success',
  FAILURE: 'Tickets/CalculateByDays/Failure'
};

export const CLEAR_COSTS = {
  REQUEST: 'Tickets/ClearCosts/Request',
  SUCCESS: 'Tickets/ClearCosts/Success',
  FAILURE: 'Tickets/ClearCosts/Failure'
};

export const CREATE_CANCELLATION_REQUEST = {
  REQUEST: 'Tickets/CreateCancellationRequest/Request',
  SUCCESS: 'Tickets/CreateCancellationRequest/Success',
  FAILURE: 'Tickets/CreateCancellationRequest/Failure'
};

export const CONFIRM_CANCELLATION = {
  REQUEST: 'Tickets/ConfirmCancellation/Request',
  SUCCESS: 'Tickets/ConfirmCancellation/Success',
  FAILURE: 'Tickets/ConfirmCancellation/Failure'
};

export const REJECT_CANCELLATION = {
  REQUEST: 'Tickets/RejectCancellation/Request',
  SUCCESS: 'Tickets/RejectCancellation/Success',
  FAILURE: 'Tickets/RejectCancellation/Failure'
};

export const CONFIRM_CANCELLATION_COSTS = {
  REQUEST: '',
  SUCCESS: '',
  FAILURE: ''
};

export const CHANGE_RESPONSE = {
  REQUEST: 'Tickets/ChangeResponse/Request',
  SUCCESS: 'Tickets/ChangeResponse/Success',
  FAILURE: 'Tickets/ChangeResponse/Failure'
}
